<template>
  <div id="tag-add-new-dialog" class="custom-modal">
    <div class="modal-body">

      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie  v-if="loading == 'updateScreenLoading' && form == null" key="create-loading"  />
        <el-row v-else key="content-loading">
          <el-row :gutter="10">
            <el-col :span="24">
              <div class="registerform-input-container">

                <div class="title">
                  <div>
                    <label>{{ $t("participantManagament.segmentations.tagAddUpdate.selectGroup") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content"><span>{{ $t("participantManagament.segmentations.tagAddUpdate.selectGroupMsg") }}</span></div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content"><span>{{ $t("participantManagament.segmentations.tagAddUpdate.updateGroupList") }}</span></div>
                    <i class="cursor-pointer action-primary" :class="loading == 'refreshGroups' ? 'el-icon-loading' : 'el-icon-refresh'" @click="refreshGroups"></i>
                  </el-tooltip>
                </div>

                <el-select v-model="form.groupID" :placeholder="$t('event.filter.group')">
                  <el-option v-for="item in $store.state.groups.items" :key="item.id" :label="item.title" :value="item.id">
                  <template>
                    <i class="fas fa-square" :style="item.color"></i>
                    <span>{{item.title}}</span>
                  </template>
                  </el-option>
                </el-select>
                <span class="error">{{ $errorMessage('groupID', validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">

                <div class="custom-label">
                  <label>{{ $t("participantManagament.segmentations.tagAddUpdate.title") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content"><span>{{ $t("participantManagament.segmentations.tagAddUpdate.titleMsg") }}</span></div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>

                <el-input v-model="form.title" :placeholder="$t('participantManagament.segmentations.tagAddUpdate.titlePlaceholder')"></el-input>
                <span class="error">{{ $errorMessage('title', validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">

                <div class="custom-label">
                  <label>{{ $t("participantManagament.segmentations.tagAddUpdate.color") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content"><span>{{ $t("participantManagament.segmentations.tagAddUpdate.colorMsg") }}</span></div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>

                <el-color-picker v-model="form.color" :placeholder="$t('participantManagament.segmentations.tagAddUpdate.chooseLabelColorPlaceholder')"></el-color-picker>
                <span class="error">{{ $errorMessage('color', validationErrors) }}</span>
              </div>
            </el-col>
             <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">

                <div class="custom-label">
                  <label>{{ $t("participantManagament.segmentations.tagAddUpdate.stock") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content"><span>{{ $t("participantManagament.segmentations.tagAddUpdate.stockMsg") }}</span></div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>

                <el-input-number v-model="form.stock" :min="0"></el-input-number>
                <span class="error">{{ $errorMessage('color', validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" v-if="form">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("participantManagament.segmentations.tagAddUpdate.settings") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("participantManagament.segmentations.tagAddUpdate.settingsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">

                    <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("participantManagament.segmentations.tagAddUpdate.view") }}
                            <!-- <el-tooltip content="Content" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("participantManagament.segmentations.tagAddUpdate.viewMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.isActive"></el-switch>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="form.print ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i :class="form.print ? 'fas fa-print' : 'fas fa-print'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("participantManagament.segmentations.tagAddUpdate.cardPrinting") }}
                            <!-- <el-tooltip content="Content" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("participantManagament.segmentations.tagAddUpdate.cardPrintingMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.print"></el-switch>
                      </div>
                    </div>

                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>

<!--   
          <el-row :gutter="10" class="mt-3 ">
            <el-col :span="24">
              <el-collapse accordion>
                <el-collapse-item name="3">
                  <template slot="title"> Ayarlar </template>
                  <el-row :gutter="10">
                    <el-col :span="24">
                      <div>İçerik ile ilgili mevcut ayarlarda değişiklik yapabilirsiniz.</div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" class="mt-3">
                    <el-col :span="24">
                      <div class="registerform-input-container">
                        <div class="title">
                          <div class="title-container">
                            <label>Görüntüleme</label>
                            <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </div>
                          <el-switch v-model="form.isActive"> </el-switch>
                        </div>
                        <div class="text-field">Yayın seçeceğini kapattığınızda mobil uygulama ve diğer dijital platformlar üzerinde bu içerik katılımcılar tarafından görüntülenemezler.</div>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" class="mt-3">
                    <el-col :span="24">
                      <div class="registerform-input-container">
                        <div class="title">
                          <div class="title-container">
                            <label>Kart baskı</label>
                            <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </div>
                          <el-switch v-model="form.print"> </el-switch>
                        </div>
                        <div class="text-field">Kart baskı seçeceğini kapattığınızda bu etikete sahip kullanıcılar kayıt deskine geldiğinde basılı kart alamazlar.</div>
                      </div>
                    </el-col>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
            </el-col>
          </el-row> -->
        </el-row>
      </transition>

    </div>

    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading' && form != null">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog'); showInfo = false;">{{ $t("participantManagament.segmentations.tagAddUpdate.close") }}</el-button>
        <template v-if="form.id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
          <el-button slot="reference" type="danger" icon="fas fa-trash"> {{ $t("participantManagament.segmentations.tagAddUpdate.delete") }}</el-button>
        </el-popconfirm>
        </template>

      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'saveLoading'" :disabled="loading == 'saveLoading'" @click="save">{{ $t("participantManagament.segmentations.tagAddUpdate.save") }}</el-button>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios';
  import ItemInfo from './ItemInfo';
  import GroupAddUpdate from './GroupAddUpdate';
  export default {
    components: { ItemInfo, GroupAddUpdate },
    name: 'TagAddUpdate',
    props: ['id', 'groupId'],
    data() {
      return {
        settingsDock: false,
        form: null,
        logoPercent: 0,
        axios,
        validationErrors: [],
        showInfo: false,
        loading: false,
        timeout: null,
      };
    },
    // async mounted() {
    //   await this.refreshGroups();
    // },
    methods: {
      async refreshGroups() {
        this.loading = 'refreshGroups';
        if (this.timeout != null) clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          await this.$store.dispatch('getGroups');
          this.loading = false;
        }, 500);
      },

      deleteItem() {
        this.$emit('deleteMe', this.form.id);
        this.$emit('closeDialog');
      },
      updatedForm() {
        this.updateForm = JSON.parse(JSON.stringify(this.$store.state.groups.items.find((x) => x.id == this.form.groupID)));
        this.addGroupModal = true;
      },
      async save() {
        this.loading = 'saveLoading';
        if (this.timeout != null) clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          var res = await axios.post('segmentation/addorupdatetag', this.form);
          this.validationErrors = res.data.validationErrors;
          if (!res.data.alert.hasError) {
            this.$message.success(res.data.alert.message);
            this.form = res.data.data.item;
            await this.$store.dispatch('getGroups');
          } else {
            this.$message.error(res.data.alert.message);
          }
          this.loading = false;
        }, 500);
      },
    },

    async created() {
      this.loading = 'updateScreenLoading';
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        if (this.id != undefined || this.id != null) {
          var res = await this.$store.dispatch('getTagOne', this.id);
          if (res.data.alert.hasError) {
            this.$emit('closeDialog');
          } else {
            this.form = res.data.data.item;
          }
        } else {
          this.form = {
            id: null,
            title: null,
            color: null,
            groupID: null,
            print: true,
            description: null,
            isActive: true,
            stok: 0,
          };
        }
        this.$nextTick(() => {
          if (this.groupId != null && this.groupId != undefined) {
            this.form.groupID = this.groupId;
          }
        });
        await this.refreshGroups();
        this.loading = false;
      }, 500);
    },
  };
</script>
<style lang="less">

  .mage-maker {
    width: 100%;
    position: relative;
    border: 1px dashed #ccc;
    height: 250px;
    background-size: contain !important;
    background-position: center center !important;
    border-radius: 5px;
    background-repeat: no-repeat !important;
    .avatar-uploader {
      opacity: 0;
      transition: all 1s;
      &:hover {
        opacity: 1 !important;
      }
      & > .el-upload {
        background-color: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 250px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .group-btn-container {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    justify-content: flex-end;
    align-items: center;

    .el-button {
      padding: 4px;
      margin-left: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/TagAddUpdate.vue